import Image from 'next/image'

import { RequestByIdApiType } from '@/api/models/requests'
import { useReopenRequest } from '@/api/models/requests/hooks/useReopenRequest'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { AppButton } from '@/components/shared/button'
import { AppModal } from '@/components/shared/modal'

type Props = {
  request: RequestByIdApiType
  requestId: string
  visible: boolean
  onClose: () => void
  onCreateNewRequest: () => void
  refetchRequest: () => void
}

export const CompleteRequestModal = ({
  request,
  requestId,
  visible,
  onClose,
  onCreateNewRequest,
  refetchRequest
}: Props) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  const { mutateAsync: reopenRequest, isPending } = useReopenRequest(requestId)

  const canReturnToWork = request.isButtonUnsolvedAvailable

  const handleReopenRequest = async () => {
    await reopenRequest()
    refetchRequest()
    onClose()
  }

  return (
    <AppModal
      overlayClassName="!bg-black/50"
      className="mx-16 w-[460px] sm:!h-auto sm:!rounded-16"
      headerWrapperClassName="!pl-32 !pr-20 !pb-12 sm:!p-16 sm:!pb-24"
      closeButtonClassName="!h-40 !w-40 shrink-0 sm:p-4"
      contentClassName="pb-32 !mt-0 gap-y-20 !overflow-y-auto sm:px-24 sm:pb-24"
      header="Обращение выполнено"
      opened={visible}
      onClose={onClose}
    >
      <div className="flex flex-col items-center text-center">
        <Image
          src="/images/shared/MessageCross.png"
          width={140}
          height={140}
          alt="Чат недоступен"
        />
        {canReturnToWork ? (
          <p className="w-[370px] pb-12 pt-20 text-grey-70 text-20 sm:text-18">
            Оставить сообщение в чате выполненного обращения невозможно. Если
            проблема не решена, верните обращение на доработку.
          </p>
        ) : (
          <p className="w-[370px] pb-12 pt-20 text-grey-70 text-20 sm:text-18">
            Оставить сообщение в чате выполненного обращения невозможно. Если
            проблема не решена, создайте новое обращение.
          </p>
        )}
      </div>

      <div className="flex flex-col gap-12">
        {canReturnToWork ? (
          <AppButton
            variant="secondary"
            fluid
            size={isMobileScreen ? 'small' : 'large'}
            disabled={isPending}
            onClick={handleReopenRequest}
          >
            Вернуть на доработку
          </AppButton>
        ) : (
          <AppButton
            variant="secondary"
            size={isMobileScreen ? 'small' : 'large'}
            fluid
            onClick={onCreateNewRequest}
          >
            Создать новое обращение
          </AppButton>
        )}
      </div>
    </AppModal>
  )
}
